function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isScalar, SCALAR } from '../nodes/identity.js';
import { Scalar } from '../nodes/Scalar.js';
import { resolveBlockScalar } from './resolve-block-scalar.js';
import { resolveFlowScalar } from './resolve-flow-scalar.js';

function composeScalar(ctx, token, tagToken, onError) {
  var _ref = token.type === 'block-scalar' ? resolveBlockScalar(ctx, token, onError) : resolveFlowScalar(token, ctx.options.strict, onError),
      value = _ref.value,
      type = _ref.type,
      comment = _ref.comment,
      range = _ref.range;

  var tagName = tagToken ? ctx.directives.tagName(tagToken.source, function (msg) {
    return onError(tagToken, 'TAG_RESOLVE_FAILED', msg);
  }) : null;
  var tag;

  if (ctx.options.stringKeys && ctx.atKey) {
    tag = ctx.schema[SCALAR];
  } else if (tagName) tag = findScalarTagByName(ctx.schema, value, tagName, tagToken, onError);else if (token.type === 'scalar') tag = findScalarTagByTest(ctx, value, token, onError);else tag = ctx.schema[SCALAR];

  var scalar;

  try {
    var res = tag.resolve(value, function (msg) {
      return onError(tagToken !== null && tagToken !== void 0 ? tagToken : token, 'TAG_RESOLVE_FAILED', msg);
    }, ctx.options);
    scalar = isScalar(res) ? res : new Scalar(res);
  } catch (error) {
    var msg = error instanceof Error ? error.message : String(error);
    onError(tagToken !== null && tagToken !== void 0 ? tagToken : token, 'TAG_RESOLVE_FAILED', msg);
    scalar = new Scalar(value);
  }

  scalar.range = range;
  scalar.source = value;
  if (type) scalar.type = type;
  if (tagName) scalar.tag = tagName;
  if (tag.format) scalar.format = tag.format;
  if (comment) scalar.comment = comment;
  return scalar;
}

function findScalarTagByName(schema, value, tagName, tagToken, onError) {
  if (tagName === '!') return schema[SCALAR]; // non-specific tag

  var matchWithTest = [];

  var _iterator = _createForOfIteratorHelper(schema.tags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _tag = _step.value;

      if (!_tag.collection && _tag.tag === tagName) {
        if (_tag.default && _tag.test) matchWithTest.push(_tag);else return _tag;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _i = 0, _matchWithTest = matchWithTest; _i < _matchWithTest.length; _i++) {
    var _tag$test;

    var tag = _matchWithTest[_i];
    if ((_tag$test = tag.test) !== null && _tag$test !== void 0 && _tag$test.test(value)) return tag;
  }

  var kt = schema.knownTags[tagName];

  if (kt && !kt.collection) {
    // Ensure that the known tag is available for stringifying,
    // but does not get used by default.
    schema.tags.push(Object.assign({}, kt, {
      default: false,
      test: undefined
    }));
    return kt;
  }

  onError(tagToken, 'TAG_RESOLVE_FAILED', "Unresolved tag: ".concat(tagName), tagName !== 'tag:yaml.org,2002:str');
  return schema[SCALAR];
}

function findScalarTagByTest(_ref2, value, token, onError) {
  var atKey = _ref2.atKey,
      directives = _ref2.directives,
      schema = _ref2.schema;
  var tag = schema.tags.find(function (tag) {
    var _tag$test2;

    return (tag.default === true || atKey && tag.default === 'key') && ((_tag$test2 = tag.test) === null || _tag$test2 === void 0 ? void 0 : _tag$test2.test(value));
  }) || schema[SCALAR];

  if (schema.compat) {
    var _schema$compat$find;

    var compat = (_schema$compat$find = schema.compat.find(function (tag) {
      var _tag$test3;

      return tag.default && ((_tag$test3 = tag.test) === null || _tag$test3 === void 0 ? void 0 : _tag$test3.test(value));
    })) !== null && _schema$compat$find !== void 0 ? _schema$compat$find : schema[SCALAR];

    if (tag.tag !== compat.tag) {
      var ts = directives.tagString(tag.tag);
      var cs = directives.tagString(compat.tag);
      var msg = "Value may be parsed as either ".concat(ts, " or ").concat(cs);
      onError(token, 'TAG_RESOLVE_FAILED', msg, true);
    }
  }

  return tag;
}

export { composeScalar };